import { render, staticRenderFns } from "./ScrollTopIcon.vue?vue&type=template&id=48b677ca&"
import script from "./ScrollTopIcon.vue?vue&type=script&lang=ts&"
export * from "./ScrollTopIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports